<template>
  <div>
    <headerTop ref="store"></headerTop>
    <storeHeader
      :shopId="shopId"
      :tenantId="goodsdetails.tenantId"
      :shopName="goodsdetails.shopName"
      :logoTop="logoTop"
    ></storeHeader>
    <div class="wrapper">
      <!-- 头部 -->

      <!-- 商品 -->
      <div class="commodity">
        <div class="w11">
          <div class="cell">
            <img width="40px" src="@/assets/images/sale.png" alt="" style="vertical-align: bottom">
            <span style="font-size: 20px; line-height: 40px;margin-left: 30px">{{goodsdetails.activityName}}</span>
          </div>
          <div class="cell">
            <span style="line-height: 40px;font-size: 16px;">活动价格</span>
            <span style="line-height: 40px;margin-left: 60px;font-size: 24px;font-weight: 700;color: #e90d0d">{{ '¥' + goodsdetails.totalPrice}}</span>
          </div>
          <div class="cell">
            <span style="line-height: 40px;font-size: 16p">活动时间</span>
            <span style="line-height: 40px;margin-left: 60px;font-size: 16p">剩余{{goodsdetails.timeHorizon}}</span>
            <span style="line-height: 40px;margin-left: 10px;font-size: 16p">{{goodsdetails.startTime}}至{{goodsdetails.endTime}}</span>
          </div>
          <div class="buygoods">
            <span
              style="margin-right: 60px;"
              >购买数量</span
            >
            <div class="number-in">
              <Button
                style="border-right: 1px solid #dcdee2"
                class="number-sub"
                @click="cliSub(goodsdetails)"
                :disabled="goodsdetails.Sub"
                >-</Button
              >
              <input
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                id="inputValue"
                v-model="goodsdetails.maxNum"
                style="width: 53px; text-align: center; line-height: 31px"
              />
              <Button
                class="number-add"
                @click="cliAdd(goodsdetails)"
                :disabled="goodsdetails.Add"
                >+</Button
              >
            </div>
            <div
              :class="goodsdetails.isNumber ? 'show' : ''"
              class="number-sp"
            >
              库存不足
            </div>
            <span class="pricetotalprice">{{
              '¥' + allprice
            }}</span>
          </div>
          <div class="purchase" v-if="!goodsdetails.inquiry">
            <div>
              <button class="btn" v-noresub="1000" @click="promptlybuy">
                立即购买
              </button>
            </div>
          </div>
        </div>
        <!-- 右边 -->
        <div class="detail_right">
          <h3>
            <i class="iconfont icon-a-zu248"></i>
            {{ goodsdetails.shopName }}
          </h3>
          <p>
            <i class="iconfont icon-a-lujing147"></i>
            本店热销
          </p>
          <ul>
            <li v-for="(item, index) in hotlist" :key="index">
              <a :href="'/Partsdetails?partId=' + item.id">
                {{
                  (item.stdNameJp == null ? '' : item.stdNameJp) +
                  (item.oeCode == null ? '' : item.oeCode)
                }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 组合详情 -->
      <div class="count">
        <p>组合详情</p>
        <div style="padding: 10px; border-radius: 8px" class="fl" v-for="(i,ind) in goodsdetails.detailVos" :key="ind">
          <!-- 内容 -->
          <Row>
            <Col span="18">
              <div>
                <div class="title" style="padding-bottom: 8px">
                  <!-- <img width="24px" src="@/assets/images/sale.png" alt="" style="vertical-align: bottom"> -->
                  <span class="brand">{{i.qualityTypeName}}</span>
                  <a style="font-weight: 700" @click="goDetails(i)">{{i.oeCode}}</a>
                </div>
                <div style="padding-bottom: 8px">{{i.carBrandName}}</div>
                <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;padding-bottom: 8px">{{i.fullName}}</div>
                <div class="oe-p" @mouseleave="closeRelevance(ind)" style="padding-bottom: 8px">
                  <p
                    @mouseenter="getRelevance(ind, i)"
                    v-if="i.oeCodeList.length"
                    style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis"
                  >
                    OE号：{{ i.oeCodeList[0]
                    }}<i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="i.oeCodeList.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    v-if="i.oeCodeList.length > 1"
                  >
                    <div
                      class="relevanceBox"
                      :class="i.isShow ? 'show' : ''"
                    >
                      <p v-for="p in i.oeCodeList.slice(1)" :key="p">
                        {{ p }}
                      </p>
                    </div>
                  </div>
                </div>
                <div>非活动价：<span style="color: #e61717">{{i.price}}</span></div>
              </div>
            </Col>
            <Col span="6" style="display: flex;flex-direction: column;justify-content: center;font-size: 20px;font-weight: 700;ext-align: center">
              <div>{{i.giveNum}}{{i.unitId}}</div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <footerP></footerP>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
    <Slider></Slider>
  </div>
</template>

<script>
// import PicZoom from 'vue-piczoom'
import headerTop from '@/views/base/common/header-top.vue'
import storeHeader from '@/views/base/common/store-Header.vue'
import Footer from '@/views/base/common/footer.vue'
import footerP from '@/views/base/common/footer-p.vue'
// import xiaopei from '@/views/xiaopei/index.vue'
import enquirytk from '@/views/base/common/enquirytk.vue'
import {
  gethotsell,
  getshopcar,
  // deleteCount,
  getbuygoods,
  getpromptlybuy1,
  getgoodsdetailsGroup,
  getBasicShopMsg,
  getattention
  // getWare,
  // getStock
} from '../../api/Partsdetails'
import { getGoodsMassage } from '../../api/myweb/goods/goodsManage'
// import registerVue from '../base/login/register.vue'
import Slider from '@/views/base/common/slider.vue'
export default {
  components: {
    // PicZoom,
    Footer,
    footerP,
    headerTop,
    storeHeader,
    // xiaopei,
    enquirytk,
    Slider
  },
  data() {
    return {
      show: false,
      // leagueId: this.$route.query.leagueId,
      wareid: '',
      wareName: '',
      warelist: [], // 发货仓数据
      imgUrlList: [], // 商品的图片
      imgActiveIndex: 0, // 当前移动图片的索引值
      imgDistance: 0, // 移动的距离
      allDistance: 0, // 总移动距离
      //大图片默认显示第一张
      mainImgUrl: '',
      // mainImgUrl:require('@/assets/images/main/normal_for_test.jpg'),
      enquirydata: {}, // 询价数据
      html: '', // 富文本渲染
      single: false, // 最小计量单位
      hotlist: [], // 热销数据
      // goodslist: [], // 商品的四张图片
      // bigImg: '', // 第一张图片
      tabIndex: 0, // 切换tabs
      parameterlist: [],
      goodsdetails: {}, //数据
      details: '', // 详情
      id: '', //跳转热销的id
      shopId: '', // 热销的id
      googsDetails: {}, // 传过来的
      carlist: [], // 车辆的品牌
      carchecked: 0, // 车辆颜色的对比
      carchecked1: 0, // 车辆颜色的对比
      carchecked2: 0, // 车辆颜色的对比
      carchecked3: 0, // 车辆颜色的对比
      tableData: [], // 表格
      partId: '', // 进入页面的id
      allprice: '', // 总价
      partsalias: '', // 别名
      logoTop: '', // 顶部图片
      carBrandName: '', // 车厂牌
      factoryName: '', // 主机厂
      carBrandSeriesName: '', // 车系
      ladder: [],
      brandlist123: [], // 车厂牌
      mainframelist: [], // 主机厂
      Demiolist: [], // 车系
      partsSpecVOList: [], // 规格参数
      Packagelenth: '', // 这个是原厂配件号
      copyPrice: ''
    }
  },
  created() {
    this.getgoods()
  },
  computed: {
    imgStyle() {
      return {
        transform: `translate3d(${this.imgDistance}px, 0, 0)` // 计算移动的距离(x,y,z)
      }
    }
  },
  methods: {
     // oe展开
    getRelevance(index, v) {
      console.log(v,'--------zhankai');
      this.$set(this.goodsdetails.detailVos[index], 'isShow', true)
    },
    // 关闭oe
    closeRelevance(index) {
      console.log(index,'--------guanbi');
      this.$set(this.goodsdetails.detailVos[index], 'isShow', false)
    },
    // 所有的商品详情
    async getgoods() {
      this.partId = this.$route.query.partId
      const res = await getgoodsdetailsGroup({
        //    这个接口作用
        activityId: this.partId
      })
      if (res.status) {
        res.data.maxNum = 1
        this.goodsdetails = res.data
        this.allprice = this.goodsdetails.maxNum * this.goodsdetails.totalPrice
        // 获取商品右侧热销
        this.gethold()
      } else {
        this.$Message.error(res.message)
      }
    },
    // 跳转订单详情
    goDetails(item) {
      this.$router.push({
        path: '/Partsdetails',
        query: {
          partId: item.partsId
        }
      })
    },
    // 数据失焦时触发
    // async BlurNumber(goodsdetails) {
    //   console.log(goodsdetails)
    //   if (
    //     this.goodsdetails.stock == 0 &&
    //     this.goodsdetails.orderQuantity == null
    //   ) {
    //     this.goodsdetails.maxNum = 1
    //   }
    //   let reg = /^[1-9]\d*$/
    //   if (!reg.test(goodsdetails.maxNum)) {
    //     this.$Message.error('请输入正确的购买数量！')
    //   } else {
    //     if (goodsdetails.inquiry == 1) {
    //     } else {
    //       if (
    //         goodsdetails.maxNum > goodsdetails.stock ||
    //         goodsdetails.maxNum == goodsdetails.stock
    //       ) {
    //         this.$set(this.goodsdetails, 'Add', true)
    //         if (goodsdetails.maxNum > goodsdetails.stock) {
    //           goodsdetails.isNumber = true
    //         } else if (goodsdetails.maxNum == goodsdetails.stock) {
    //           this.$set(this.goodsdetails, 'isNumber', false)
    //         }
    //       } else {
    //         this.$set(this.goodsdetails, 'Add', false)
    //         this.$set(this.goodsdetails, 'isNumber', false)
    //       }
    //       let a = ''
    //       a = {
    //         tenantId: this.goodsdetails.tenantId,
    //         shopId: this.goodsdetails.shopId,
    //         partId: this.partId,
    //         partNum:
    //           this.goodsdetails.maxNum == null
    //             ? this.goodsdetails.orderQuantity
    //             : this.goodsdetails.maxNum,
    //         storeId: this.wareid
    //       }
    //       const res = await getbuygoods(a)
    //       console.log(res, '999')
    //       if (res.status) {
    //         this.allprice = res.data.amount
    //         this.goodsdetails.price = res.data.price
    //       }
    //     }
    //   }
    //   //   // }
    //   // }
    // },
    // 减法
    cliSub(goodsdetails) {
      if (goodsdetails.maxNum == 1) {
        // this.$set(this.dataList[index], 'Sub', true)
      } else {
        let oipt = document.getElementById('inputValue')
        console.log(oipt)
        this.$delete(this.goodsdetails, 'maxNum')
        this.$set(this.goodsdetails, 'maxNum', oipt.value * 1 - 1)
        // this.BlurNumber(goodsdetails)
      }
      this.allprice = this.goodsdetails.maxNum * this.goodsdetails.totalPrice
    },
    // 加法
    cliAdd(goodsdetails) {
      let oipt = document.getElementById('inputValue')
      this.$delete(this.goodsdetails, 'maxNum')
      this.$set(this.goodsdetails, 'maxNum', oipt.value * 1 + 1)
      this.allprice = this.goodsdetails.maxNum * this.goodsdetails.totalPrice
      // this.BlurNumber(goodsdetails)
    },

    // 热销
    async gethold() {
      const res = await gethotsell({
        num: 5,
        shopId: this.shopId,
        tenantId: this.goodsdetails.tenantId
      })
      //console.log(res)
      if (res.status) {
        this.hotlist = res.data.list
      } else {
        this.$Message.error(res.message)
      }
    },

    // 加入购物车
    // async addcar() {
    //   if (this.goodsdetails.maxNum < this.goodsdetails.orderQuantity) {
    //     this.$Message.destroy()
    //     this.$Message.error('购买数量不能小于起订数量')
    //     return
    //   }
    //   if (
    //     this.goodsdetails.stock !== 0 &&
    //     this.goodsdetails.stock >= this.goodsdetails.orderQuantity
    //   ) {
    //     let data = ''
    //     data = {
    //       tenantId: this.goodsdetails.tenantId,
    //       shopId: this.shopId,
    //       shopName: this.goodsdetails.shopName,
    //       partId: this.partId,
    //       partCode: this.goodsdetails.oeCode,
    //       partNum: this.goodsdetails.maxNum
    //         ? this.goodsdetails.maxNum
    //         : this.goodsdetails.orderQuantity,
    //       partQualityType: this.goodsdetails.qualityTypeId,
    //       carBrandName: this.goodsdetails.carBrandName,
    //       partInnerId: this.goodsdetails.partInnerId,
    //       direction: this.goodsdetails.direction
    //         ? this.goodsdetails.direction
    //         : '',
    //       price: this.goodsdetails.price,
    //       stdNameJp: this.goodsdetails.stdNameJp
    //         ? this.goodsdetails.stdNameJp
    //         : '',
    //       storeId: this.wareid
    //     }
    //     const res = await getshopcar(data)
    //     //console.log(res)
    //     if (res.status) {
    //       this.$Message.destroy()
    //       this.$Message.success('加入购物车成功')
    //       this.$nextTick(() => {
    //         this.goodsdetails.maxNum = this.goodsdetails.orderQuantity
    //         this.allprice =
    //           this.goodsdetails.price * this.goodsdetails.orderQuantity
    //         this.$refs.store.getCount()
    //       })
    //     }
    //   } else {
    //     this.$Message.destroy()
    //     this.$Message.error('库存不足')
    //   }
    // },
    // 收藏
    async collect(item) {
      item.attention = !item.attention
      //console.log('收藏')
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      const res = await getattention({
        partId: item.id,
        attention: item.attention
      })
      //console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
      // 收藏
      // if (this.flag) {
      //   console.log('取消收藏')
      // } else {
      //   console.log('收藏成功')
      // }
    },
    // 立即购买
    async promptlybuy() {
      console.log(this.goodsdetails.maxNum , this.goodsdetails.orderQuantity);
      console.log(this.goodsdetails.stock,this.goodsdetails.stock,this.goodsdetails.orderQuantity);
      if (this.goodsdetails.maxNum) {
        let data = []
        this.goodsdetails.detailVos.map(item => {
          let obj = {
            partId: item.partsId,
            tenantId: this.goodsdetails.tenantId,
            partNum: this.goodsdetails.maxNum * item.giveNum,
            shopId: null,
            storeId: this.goodsdetails.storeId
          }
          data.push(obj)
        })
        // if (this.$route.query.leagueId) {
        // data = {
        //   partId: this.partId, // 商品id
        //   tenantId: this.goodsdetails.tenantId, // 店铺的租户id
        //   partNum: this.goodsdetails.maxNum, // 购买数量
        //   shopId: null, // 热销id
        //   storeId: this.goodsdetails.storeId
        // }
        console.log(data);
        const res = await getpromptlybuy1(data)
        //console.log(res)
        if (res.status) {
          this.$router.push({
            path: '/orderInformation',
            query: { pid: res.data.previewOrderId, activityType: '3'}
          })
        }
      } else {
        this.$Message.destroy()
        this.$Message.error('请填写购买数量')
      }
    },
    // 立即询价
    promptlyxj(item) {
      // this.enquirytk = true
      this.$refs.enquirytkl.enquirytkc()
      this.enquirydata = JSON.parse(JSON.stringify(item))
    },
    // 询价刷新
    enquirysx() {
      this.$refs.store.getenquirydata()
    },
    // 顶部图片
    async getshopping() {
      const res = await getBasicShopMsg({
        tenantId: this.goodsdetails.tenantId,
        shopId: this.shopId
      })
      //console.log(res)
      if (res.status) {
        if (res.data) {
          this.logoTop = res.data.logoTop
        }
      }
    },
    // 切换发货仓
    changeware(i) {
      console.log(i)
      this.wareName = i.city + i.name
      this.wareid = i.storeId
      this.goodsdetails.stock = i.stock
      this.goodsdetails.stockShow = i.stock
      this.goodsdetails.maxNum = 1
      this.goodsdetails.minNum = 1
      this.allprice = this.copyPrice
      // this.getStock()
    },
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
.detail {
  display: inline-block;
  width: 30%;
}
.red {
  color: #d9001b;
}
.oe-p {
  font-size: 14px;
  position: relative;
  p {
    text-align: left;
    font-size: 14px;
  }
  p:hover .ivu-icon-ios-arrow-down {
    transform: rotate(-180deg);
  }
  .ivu-icon-ios-arrow-down {
    font-size: 14px;
    cursor: pointer;
    transition: all 0.5s ease 0s;
  }
  .ivu-icon-ios-arrow-down:hover {
    transform: rotate(-180deg);
  }
  span {
    cursor: pointer;
  }
  .relevanceBox {
    padding: 2px 15px 2px 2px;
    position: absolute;
    top: 20px;
    left: 43px;
    height: auto;
    border: 1px solid #e2e2e2;
    background-color: #fff;
    display: none;
    z-index: 99;
    overflow-y: auto;
    word-wrap: break-word;
    span {
      font-size: 12px;
      line-height: 18px;
      font-weight: normal;
      padding-bottom: 6px;
    }
  }
  .show {
    display: block;
  }
}
.brand{
  border-radius: 5px;
  display: inline-block;
  width: 75px;
  background-color: #f59a23;
  text-align: center;
  color: #fff;
  margin-right: 18px;
}
.cell {
  width: 100%;
  height: 40px;

}
</style>
